import { Typography } from "@mui/material";
import WhiteCard from "src/shared/components/WhiteCard";

interface Props {
  title: string;
  text: string;
  onNavigate: () => void;
}

const InformationCard = ({ text, title, onNavigate }: Props) => {
  return (
    <WhiteCard
      sx={{ background: "rgba(0, 181, 184, 0.25)", borderRadius: "30px" }}
      gap={1}
      onClick={onNavigate}
    >
      <Typography variant="h5" fontWeight={600}>
        {title}
      </Typography>
      <Typography>{text}</Typography>
    </WhiteCard>
  );
};

export default InformationCard;
